import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import { AdyenState } from '../types'
import * as actions from './actions'
import { initialState } from './initialState'

const initAdyenSDKSuccess = (state): AdyenState => ({
  ...state,
  sdkLoaded: true,
})

const initAdyenCheckout = (state, { action, config }): AdyenState => ({
  ...state,
  actionObject: action,
  config,
  initStatus: LoadingStates.LoadedSuccess,
})

const completeAdyenCheckout = (state): AdyenState => ({
  ...state,
  actionObject: null,
  initStatus: LoadingStates.NotLoaded,
})

const apiInitAdyenStart = (state): AdyenState => ({
  ...state,
  initStatus: LoadingStates.Loading,
})

const apiInitAdyenSuccess = (state, { action, config }): AdyenState => ({
  ...state,
  actionObject: action,
  config,
  initStatus: LoadingStates.LoadedSuccess,
})

const apiInitAdyenFail = (state): AdyenState => ({
  ...state,
  initStatus: LoadingStates.LoadedFail,
})

export default createReducer((on) => {
  on(actions.initAdyenSDKSuccess, initAdyenSDKSuccess)
  on(actions.initAdyenCheckout, initAdyenCheckout)
  on(actions.completeAdyenCheckout, completeAdyenCheckout)
  on(actions.apiInitAdyenStart, apiInitAdyenStart)
  on(actions.apiInitAdyenSuccess, apiInitAdyenSuccess)
  on(actions.apiInitAdyenFail, apiInitAdyenFail)
}, initialState)
